<template data-view>
    <div class="loading-full-page" v-if="isLoadingPagePayment">
            <b-card>
                <b-skeleton animation="wave" width="85%"></b-skeleton>
                <b-skeleton animation="wave" width="55%"></b-skeleton>
                <b-skeleton animation="wave" width="70%"></b-skeleton>
            </b-card>
    </div>
    <tetemplate v-else>
        <SideBar v-if="isShowPage" :is-hide-menu="step === 4 || step === 3">
                <div class="section-wallet" :class="{ 'no-padding': step !== 1 }">
                    <template v-if="step === 1">
                        <div class="section-wallet__header section-wallet__padding-container">
                            <div class="section-wallet__header-content__desktop">
                                <h1
                                    class="section-wallet__title__desktop t-transform-cap"
                                >
                                    {{ getTranslatedText("my wallet") }}
                                    <img
                                        src="@/assets/images/wallet/vector.png"
                                        @click="onShowBottomMenuList"
                                    />
                                </h1>
                                <div
                                    class="section-wallet__header-content__desktop__items"
                                >
                                    <h1 class="section-wallet__balance__desktop">
                                        <span
                                            class="section-wallet__text-credit t-transform-cap"
                                            >{{
                                                getTranslatedText("my credit balance")
                                            }}</span
                                        >
                                        <div class="section-wallet__number-balance">
                                            {{ formatPrice($store.state.balance) }}
                                            <span>{{
                                                getTranslatedText($store.state.currency_code)
                                            }}</span>
                                        </div>
                                    </h1>
                                    <div class="section-wallet__box-btn__desktop">
                                        <button
                                            @click="onShowVoucherCode"
                                            class="section-wallet__btn-withdraw section-wallet__btn-white-desktop section-wallet__btn-voucher t-transform-cap"
                                        >
                                            + {{ getTranslatedText("Use Voucher Code") }}
                                        </button>
                                        <button
                                            @click="onShowAddCredit"
                                            class="section-wallet__btn-withdraw section-wallet__btn-white-desktop t-transform-cap"
                                        >
                                            + {{ getTranslatedText("Add Credit") }}
                                        </button>
                                        <button
                                            class="section-wallet__btn-withdraw section-wallet__btn-default-desktop t-transform-cap"
                                            @click="onClickWithDraw(3)"
                                        >
                                            {{ getTranslatedText("User transfer") }}
                                            <img
                                                src="@/assets/images/common/arrow-right.png"
                                            />
                                        </button>
                                        <button
                                            class="section-wallet__btn-withdraw section-wallet__btn-default-desktop t-transform-cap"
                                            @click="onClickWithDraw(2)"
                                        >
                                            {{ getTranslatedText("Bank Withdrawal") }}
                                            <img
                                                src="@/assets/images/common/arrow-right.png"
                                            />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="section-wallet__body section-wallet__padding-container">
                            <div class="section-wallet__container">
                                <h1
                                    class="section-wallet__body-title t-fir-transform-cap"
                                >
                                    {{
                                        getTranslatedText(
                                            "Total winnings:"
                                        )
                                    }}
                                    <span> {{ formatPrice(totalWinnings) }} {{ getTranslatedText(currency_code) }}</span>
                                </h1>
                                <p
                                    class="section-wallet__body-description t-fir-transform-cap"
                                >
                                    {{
                                        getTranslatedText(
                                            "Winning amount will be transferred to your credit balance automatically."
                                        )
                                    }}
                                    <br>
                                    {{
                                        getTranslatedText(
                                            "Your selected numbers that match the winning combination will be highlighted."
                                        )
                                    }}
                                </p>
                            </div>
                            <div class="section-wallet__body-balls">
                                <NoEmpty
                                    v-if="listBalls.length === 0"
                                    :text="getTranslatedText('no data')"
                                />
                                <template v-else>
                                    <h6
                                        class="section-wallet__body-balls-title section-wallet__container t-transform-cap"
                                    >
                                        {{ getTranslatedText("past winnings") }}
                                    </h6>
                                    <ul class="section-wallet__body-list-balls">
                                        <li
                                            v-for="(item, index) in listBalls"
                                            :key="index"
                                            class="section-wallet__body-item-balls"
                                        >
                                            <div
                                                class="section-wallet__list-ball-select section-wallet__container"
                                            >
                                                <div
                                                    v-for="(number, i) in item.ballsFinal"
                                                    :key="i"
                                                    :class="[`section-wallet__item-ball-select ${renderClass(
                                                        number.number,
                                                        i
                                                    )}`, { highLight: number.isHighlight }]"
                                                >
                                                    <div
                                                        class="section-wallet__box-ball-select"
                                                    >
                                                        {{ formatNumber(number.number) }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="item.raffle_code && Number(item.raffle_winnings) > 0" class="section-wallet__container section-wallet__container__flex no-padding">
                                                <p class="section-wallet__item-balls-price t-transform-cap">
                                                    {{
                                                        getTranslatedText(
                                                            "raffle code"
                                                        )
                                                    }}:
                                                    <span>{{ item.raffle_code }}</span>
                                                </p>
                                            </div>
                                            <div v-if="item.raffle_winnings && item.raffle_winnings !== '0'" class="section-wallet__container section-wallet__container__flex">
                                                <p class="section-wallet__item-balls-price t-transform-cap">
                                                    {{
                                                        getTranslatedText(
                                                            "raffle winnings"
                                                        )
                                                    }}:
                                                    <span>{{ formatPrice(item.raffle_winnings) }} {{ getTranslatedText(currency_code) }} </span>
                                                </p>
                                                <p
                                                    class="section-wallet__item-balls-date"
                                                    v-if="!parseInt(item.price)"
                                                >
                                                    {{  getTranslatedText('draw date') }}: {{ item.date }}
                                                </p>
                                            </div>
                                            <div v-if="parseInt(item.price)" class="section-wallet__container section-wallet__container__flex">
                                                <p
                                                    class="section-wallet__item-balls-price t-transform-cap"
                                                >
                                                    {{
                                                        getTranslatedText(
                                                            "winning amount"
                                                        )
                                                    }}:
                                                    <span
                                                        >{{ formatPrice(item.price) }}
                                                        {{ getTranslatedText(currency_code) }}</span
                                                    >
                                                </p>
                                                <p
                                                    class="section-wallet__item-balls-date"
                                                >
                                                    {{  getTranslatedText('draw date') }}: {{ item.date }}
                                                </p>
                                            </div>
                                        </li>
                                    </ul>
                                </template>
                            </div>
                            <div
                                v-if="listBalls.length > 0"
                                class="section-wallet__pagination"
                            >
                                <div class="section-wallet__pagination__count">
                                    {{pageCount}}/{{totalPage }}
                                </div>
                                <b-pagination
                                    v-model="pageWinningbets"
                                    :total-rows="totalPage"
                                    :per-page="perPage"
                                ></b-pagination>
                            </div>
                        </div>
                        <div class="section-wallet__winning-prizes">
                            <div class="draws__content__past__title section-wallet__past__title">
                                {{ getTranslatedText("winnings Prizes") }}
                            </div>
                            <NoEmpty
                                v-if="listWinnings.length === 0"
                                :text="getTranslatedText('no data')"
                            />
                            <div v-else class="draws__content__winnings__list">
                                <div
                                    v-for="(item, i) in listWinnings"
                                    :key="i"
                                    class="draws__content__winnings__item section-wallet__winnings__item"
                                >
                                    <p class="draws__content__winnings__item__text">
                                        {{ getTranslatedText(item.name) }}
                                    </p>
                                    <p class="draws__content__winnings__item__price">
                                        {{ getTranslatedText(currencyCode) }} {{ fomarNumberWinners(item.prize) }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </template>

                    <template v-if="step === 2">
                        <BankTransfer
                            :isLoadingButton="isLoadingButton"
                            @onClickGoBack="onClickGoBack"
                            @onSubmit="onSubmitWithdrawal"
                            @showToast="showToast"
                        />
                    </template>
                    <template v-if="step === 3">
                        <MobileNumber
                            :isLoadingButton="isLoadingButton"
                            @onClickGoBack="onClickGoBack"
                            @onSubmit="onSubmitTransferAmount"
                            @showToast="showToast"
                        />
                    </template>

                    <template v-if="step === 4">
                        <AddCredit
                            :offsite="offsite"
                            @onClickGoBack="onClickGoBack"
                            @showToast="showToast"
                        />
                    </template>
                    <template v-if="step === 5">
                        <AddVoucher 
                            @showToast="showToast"
                            @onClickGoBack="onClickGoBack"
                        />
                    </template>
                    <VoucherCode
                        id="modalVoucherCodeWallet"
                        @showToast="showToast"
                        @onCancelModal="onHideVoucherCode"
                    />
                    <vue-bottom-sheet max-height="90%" ref="bottomMenuList">
                        <BottomSheet :isHiddenBtn="true">
                            <template slot="body-sheet">
                                <ul class="bottom-sheet-list-navigation__menu-list">
                                    <li
                                        v-for="(item, index) in listMenuNavigation"
                                        :key="index"
                                        v-show="item.isShow"
                                        class="bottom-sheet-list-navigation__menu-item"
                                    >
                                        <div
                                            @click="handleClickRedirect(item)"
                                            class="bottom-sheet-list-navigation__menu-item-content t-transform-cap"
                                        >
                                            <img
                                                class="user-avatar"
                                                :src="
                                                    require(`@/assets/images/navigation/${item.icon}`)
                                                "
                                                :alt="item.icon"
                                            />
                                            {{ getTranslatedText(item.title) }}
                                        </div>
                                    </li>
                                </ul>
                            </template>
                        </BottomSheet>
                    </vue-bottom-sheet>

                    <vue-bottom-sheet
                        max-height="90%"
                        ref="bottomMenuWithdraw"
                        :background-scrollable="false"
                    >
                        <BottomSheet>
                            <div slot="body-sheet" class="bottom-sheet__width-draw">
                                <h1 class="bottom-sheet__width-draw-title">
                                    {{ getTranslatedText("transfer / withdraw") }}
                                </h1>
                                <div class="bottom-sheet__width-draw-form">
                                    <FormCommon
                                        :formItem="formItem"
                                        :dataForm="dataForm"
                                        @update-form-data="updateWithDraw"
                                        @onSubmitForm="onSubmitWithdraw"
                                    />
                                </div>
                                <ButtonCustom
                                    classBtn="bottom-sheet__width-draw-button"
                                    typeBtn="button"
                                    type="primary"
                                    text="continue"
                                    icon="arrow-right.png"
                                    @onClickButton="onClickWithDraw"
                                />
                            </div>
                        </BottomSheet>
                    </vue-bottom-sheet>
                    <Toast :title="toastData.message" :type="toastData.type" />
                </div>
        </SideBar>
    </tetemplate>
</template>
<script>
import { listMenuNavigation } from "@/resources/listNavigation";
import {
    isArrayEmpty,
    isStrEmpty,
    redirectPathApp,
    renderClassBall,
    renderLocaleNumber,
    renderLocalePrice,
} from "@/components/common/utils";

import toolService from "@/services/tool.service";
// import WalletService from "@/services/wallet.service";
import PaymentService from "@/services/payment.servive";

import BottomSheet from "@/components/common/bottom-sheet";
import FormCommon from "@/components/common/form";
import ButtonCustom from "@/components/common/button";
import NoEmpty from "@/components/common/no-empty";

import BankTransfer from "@/views/mobile/wallet/bank-transfer";
import MobileNumber from "@/views/mobile/wallet/mobile-number";
import AddCredit from "@/views/mobile/wallet/add-credit";
import authService from "@/services/auth.service";
import walletService from "@/services/wallet.service";
import SideBar from "@/components/common/sidebar/SideBar";

import LanguageMixin from "@/mixins/language/language-mixin";
import RouterMixin from "@/mixins/router/router-mixin"
import Toast from "@/components/common/toast/Toast.vue";
import moment from 'moment';
import DrawsService from "@/services/draws.service";
import paymentMixin from "@/mixins/payment/payment-mixin"
import VoucherCode from "@/components/common/voucherCode";
import AddVoucher from "@/views/mobile/wallet/add-voucher";
import EventBus from '@/components/common/EventBus';

const CURRENCY_CODE = process.env.VUE_APP_CURRENCY_CODE;

export default {
    mixins: [LanguageMixin, RouterMixin, paymentMixin],
    components: {
        BottomSheet,
        FormCommon,
        ButtonCustom,
        BankTransfer,
        MobileNumber,
        AddCredit,
        NoEmpty,
        SideBar,
        Toast,
        VoucherCode,
        AddVoucher
    },

    data() {
        return {
            perPage: 10,
            pageWinningbets: 1,
            totalPage: 1,
            pageCount: 0,
            listWinnings: [],
            isShowPage: false,
            toastData: {
                message: "",
                type: "success",
            },
            step: 1,
            offsite: false,
            isLoadingButton: false,
            balance: "0.00",
            totalWinnings: "0.00",
            currency_code: "OMR",
            currencyCode: CURRENCY_CODE,
            listMenuNavigation,
            dataForm: {
                methodsWithDraw: "1",
            },
            listBalls: [],
            formItem: [
                {
                    type: "radio",
                    name: "methodsWithDraw",
                    label: "",
                    required: false,
                    id: "input-methodsWithDraw",
                    options: [
                        {
                            text: this.getTranslatedText("bank transfer"),
                            value: "1",
                        },
                        {
                            text: this.getTranslatedText(
                                "to mobile number/email"
                            ),
                            value: "2",
                        },
                    ],
                },
            ],
        };
    },
    created() {
        this.fetchDataValidateBall();
        this.fetchData();
        this.getListPastDraws();
        this.$store.dispatch("setBalance");
        this.$store.dispatch("getListGame");
        window.addEventListener("resize", this.myEventHandler);
    },
    destroyed() {
        window.removeEventListener("resize", this.myEventHandler);
    },
    mounted() {
        const parameters = this.$route.query;
        if(parameters?.step === '4') {
            this.onShowAddCredit()
            this.$router.replace({'query': null});
        } else if(parameters?.step === '5') {
            this.step = 5;
            this.isShowPage = true
            this.$router.replace({'query': null});
        } else {
            this.isShowPage = true
        }
    },
    watch: {
        pageWinningbets(val) {
            if(val) {
                this.pageWinningbets = val;
                this.fetchData();
            }
        }
    },
    methods: {
        myEventHandler(e) {
            if (!(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) && this.step === 5) {
                this.step = 1;
            } 
        },
        fomarNumberWinners(price) {
            price = renderLocaleNumber(parseFloat(price))
            return price;
        },
        async getListPastDraws() {
            try {
                const resp = await DrawsService.listPastDraws()
                if(resp.status === "success" && !isArrayEmpty(resp.data) && !isArrayEmpty(this.$store.state.listGameLoto) ) {
                    resp.data[0].tiers[0].prize = this.$store.state.listGameLoto[0].estimated_jackpot
                    resp.data[0].tiers.push({
                        name: 'raffle id match',
                        prize: "10000"
                    })
                    this.listWinnings = resp.data[0].tiers
                }
            } catch (error) {
                console.log(error)
            }
        },
        showToast(message, type) {
            this.toastData.message = message && this.getTranslatedText(message);
            this.toastData.type = type;
            this.$bvToast.show("my-toast");
        },

        onShowVoucherCode() {
            if (
                /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                    navigator.userAgent
                )
            ) {
                this.step = 5;
            } else {
                this.$bvModal.show("modalVoucherCodeWallet");
            }    
        },

        onHideVoucherCode() {
            EventBus.$emit('onHideVoucherCode');
            this.$bvModal.hide("modalVoucherCodeWallet");
        },

        async fetchData() {
            try {
                const respWinning = await walletService.getWinning(this.pageWinningbets, this.perPage);

                if (
                    respWinning.status === 200 &&
                    !isArrayEmpty(respWinning.data)
                ) {
                    this.totalPage = respWinning.total;
                    this.pageCount = this.perPage*this.pageWinningbets;
                    if(this.pageCount > this.totalPage) {
                        this.pageCount = this.totalPage;
                    }

                    let listBalls = respWinning.data.map((v) => {
                        let balls = [];
                        let ballsResults = [];
                        let ballsFinal = [];

                        let bet = JSON.parse(v?.bet);
                        let results = JSON.parse(v?.results);
                        bet.bets.map((x) => {
                            balls = balls.concat(x);
                        });
                        if(results) {
                            results.map((x) => {
                                ballsResults = ballsResults.concat(x);
                            });
                        }


                        if(results) {
                            balls.map(ball => {
                                if(ballsResults.includes(ball)) {
                                    ballsFinal.push({isHighlight: true, number: ball});
                                } else {
                                    ballsFinal.push({number: ball});
                                }
                            })
                        } else {
                            balls.map(ball => {
                                ballsFinal.push({number: ball});
                            })
                        }

                        let locale = this.$store.state.isRtl ? "ar" : "en";
                        moment.locale(locale)

                        let date = moment(moment.utc(v.draw_date)).format('DD/MM/YYYY')
                        let price = parseFloat(v?.winnings?.replace(/,/g, ""))
                            .toFixed(2)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        return {
                            id: v.id,
                            balls,
                            ballsFinal,
                            price,
                            date,
                            raffle_code: v?.raffle_code?.toString() || '',
                            raffle_winnings: v?.raffle_winnings?.toString() || ''
                        };
                    });
                    this.totalWinnings = respWinning.total_winning;
                    this.listBalls = listBalls;
                }
            } catch (error) {
                console.log(error);
            }
        },
        async fetchDataValidateBall() {
            try {
                const resp = await toolService.getValidateTicket();

                this.listNumber = new Array(resp.quatityNumber);

                this.maxiumBlue = resp.maxiumBlue;
                this.maxiumGreen = resp.maxiumGreen;
                this.minimumBall = resp.minMaxTickets[0];
            } catch (err) {
                console.log(err, "err");
            }
        },

        async onSubmitWithdrawal(param) {
            this.isLoadingButton = true;

            if (isStrEmpty(param.account_name)) {
                this.showToast("The Beneficiary Name is required", "error");
                this.isLoadingButton = false;
                return false;
            }

            if (isStrEmpty(param.city)) {
                this.showToast("The City is required", "error");
                this.isLoadingButton = false;
                return false;
            }

            if (isStrEmpty(param.country)) {
                this.showToast("The Country is required", "error");
                this.isLoadingButton = false;
                return false;
            }

            if (isStrEmpty(param.bank_name)) {
                this.showToast("The Bank Name is required", "error");
                this.isLoadingButton = false;
                return false;
            }

            if (isStrEmpty(param.account_number) && param.isAccountNumber === true) {
                this.showToast("The Beneficiary Account is required", "error");
                this.isLoadingButton = false;
                return false;
            }

            if (isStrEmpty(param.bank_account_currency)) {
                this.showToast(
                    "The Bank Account Currency is required",
                    "error"
                );
                this.isLoadingButton = false;
                return false;
            }

            if (isStrEmpty(param.branch_code) && param.isIban === true) {
                this.showToast("The Iban / Clabe # is required", "error");
                this.isLoadingButton = false;
                return false;
            }

            if (isStrEmpty(param.swift_code)) {
                this.showToast("The Swift Code is required", "error");
                this.isLoadingButton = false;
                return false;
            }
            let { isIban, isAccountNumber, ...paramData } = param;

            try {
                const resp = await walletService.withdrawalBanking(paramData);
                if (resp.status === 400) {
                    !isArrayEmpty(resp.errors)
                        ? resp.errors.forEach((element) => {
                              return this.showToast(element.message, "error");
                          })
                        : this.showToast(resp.message, "error");
                } else {
                    this.$store.dispatch("setBalance");
                    this.showToast(resp.message, "success");
                    this.step = 1;
                }
                this.isLoadingButton = false;
            } catch (error) {
                console.log(error);
            }
        },

        async onSubmitTransferAmount(item) {
            this.isLoadingButton = true;
            let param = {
                amount: item.amount,
            };

            if (isStrEmpty(item.email) && isStrEmpty(item.phone)) {
                this.showToast(
                    "Please enter your phone number or email",
                    "error"
                );
                this.isLoadingButton = false;
                return false;
            }

            if (!isStrEmpty(item.email)) {
                param["email"] = item.email;
            } else {
                param["phone"] = item.phone;
                param["calling_code"] = item.calling_code;
            }
            try {
                const resp = await walletService.balanceTransfer(param);
                if (resp.status === 400) {
                    let message = "";
                    !isArrayEmpty(resp.errors)
                        ? resp.errors.forEach((element) => {
                              message += element.message;
                          })
                        : (message = resp.message);

                    this.showToast(message, "error");
                } else {
                    this.$store.dispatch("setBalance");
                    this.showToast(resp.message, "success");
                    this.step = 1;
                }
                this.isLoadingButton = false;
            } catch (error) {
                this.isLoadingButton = false;

                console.log(error);
            }
        },

        onShowBottomMenuList() {
            this.$refs.bottomMenuList.open();
        },

        onClickGoBack() {
            this.step = 1;
        },

        // with draw
        onClickWithDraw(number) {
            this.step = number ? number : this.dataForm.methodsWithDraw === "1" ? 2 : 3;
            this.$refs.bottomMenuWithdraw.close();
        },

        onShowWithdraw() {
            this.$refs.bottomMenuWithdraw.open();
        },

        onSubmitWithdraw() {
            console.log("onSubmitWithdraw");
        },

        updateWithDraw(event) {
            const { name, value } = event;
            this.dataForm[name] = value;
        },

        // on show add credit
        async onShowAddCredit() {

            const resp = await PaymentService.getGateway();

            if (resp.status === 200) {
                const data = resp.data;
                const config = data.config ? JSON.parse(data.config): null;

                if (config) {
                    const offsite = config.offsite ? config.offsite : 'no';
                    if (offsite === 'yes') {
                        this.offsite = true;
                    }
                }
                this.step = 4;
                this.isShowPage = true
            } else {
                this.step = 4;
                this.isShowPage = true
            }
        },

        renderClass(number, index) {
            return renderClassBall(
                number,
                index,
                this.minimumBall,
                this.maxiumBlue,
                this.maxiumGreen
            );
        },

        handleClickRedirect(item) {
            if (this.$store.state.is_app && item.isRedirect) {
                redirectPathApp(item.url);
            } else {
                this.routerPush(item.url);
            }
        },

        formatPrice(price) {
            price = price.replaceAll(',', '')
            return renderLocalePrice(parseFloat(price))
        },

        formatNumber(number) {
            return renderLocaleNumber(number)
        }
    },
};
</script>

<style scoped lang="scss" src="@/assets/scss/mobile/static-pages/draws.scss" />
<style scoped lang="scss" src="@/assets/scss/mobile/wallet/_wallet.scss" />
